import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.91,8a.72.72,0,0,1-.06.29,1,1,0,0,1-.16.24h0L6.46,12.61a.75.75,0,1,1-1-1.08L8.3,8.75H2a.75.75,0,0,1,0-1.5H8.3L5.42,4.47a.75.75,0,0,1,0-1.06.76.76,0,0,1,1.06,0l4.22,4.07h0a1,1,0,0,1,.16.24A.72.72,0,0,1,10.91,8Zm3.84,6V2a.75.75,0,0,0-1.5,0V14a.75.75,0,0,0,1.5,0Z';
const draw24px =
  'M16.06,12a.53.53,0,0,1,0,.25.62.62,0,0,1-.17.28l-3.55,3.56a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06l2.27-2.28H4a.75.75,0,0,1,0-1.5h9.5L11.23,9a.75.75,0,1,1,1.06-1.06l3.55,3.55a.74.74,0,0,1,.2.38A.77.77,0,0,1,16.06,12Zm4.69,8V4a.75.75,0,0,0-1.5,0V20a.75.75,0,0,0,1.5,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowAlignRightIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowAlignRight')) as IconWithRender;

ArrowAlignRightIcon.displayName = 'ArrowAlignRightIcon';
ArrowAlignRightIcon.propTypes = Icon.propTypes;
ArrowAlignRightIcon.renderIcon = (props) => <ArrowAlignRightIcon {...props} />;
export default ArrowAlignRightIcon;
